import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, } from 'react-router-dom';
import "../../css/products/productCards.css";
import Promotion from "../Home/Promotion";
import HomePageProductLists from "../AC/HomePageProductLists";
import WaveAnimation from "../AC/wawe";
import MobileAppinstruction from "../AC/MobileAppinstruction";


function ProductList() {
    const faz = "Faz";
    const tekfaz = "Tek Faz";
    const ucFaz = "Üç Faz";
    const ipClass = "IP Sınıfı";
    const ipClass54 = "IP54";
    const amper = "Akım";
    const Amper20 = "20A";
    const Amper32 = "32A";
    const kabloUzunlugu = "Kablo Uzunluğu";
    const Cable5 = "5m";
    const Cable8 = "8m";
    const kullanimi = "Kullanım";
    const ozellik = "Özellikleri";
    const prizSecenekleri = "Priz Seçenekleri";
    const fisSecenekleri = "Fiş Seçenekleri";
    const kabloSecenekleri = "Kablo Seçenekleri";
    const kabloTipi = "Kablo Tipi";

    const DualcardData = [
        {
            title: "Şarj Kablosu 1",
            image: "/assets/products/1.png",
            stats: [
                { label: faz, values: [tekfaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper20] },
                { label: kabloUzunlugu, values: [Cable5] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-seti-5m-monofaze-20a"
        },

        {
            title: "Şarj Kablosu 2",
            image: "/assets/products/2.png",
            stats: [
                { label: faz, values: [tekfaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper32] },
                { label: kabloUzunlugu, values: [Cable5] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-seti-5m-monofaze-32a"
        },
        {
            title: "Şarj Kablosu 3",
            image: "/assets/products/3.png",
            stats: [
                { label: faz, values: [tekfaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper20] },
                { label: kabloUzunlugu, values: [Cable8] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-seti-8m-monofaze-20a"
        },

        {
            title: "Şarj Kablosu 4",
            image: "/assets/products/4.png",
            stats: [
                { label: faz, values: [tekfaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper32] },
                { label: kabloUzunlugu, values: [Cable8] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-seti-8m-monofaze-32a"
        },

        {
            title: "Şarj Kablosu 5",
            image: "/assets/products/5.png",
            stats: [
                { label: faz, values: [ucFaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper20] },
                { label: kabloUzunlugu, values: [Cable5] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-seti-5m-trifaze-20a"
        },

        {
            title: "Şarj Kablosu 6",
            image: "/assets/products/6.png",
            stats: [
                { label: faz, values: [ucFaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper32] },
                { label: kabloUzunlugu, values: [Cable5] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-seti-5m-trifaze-32a"
        },

        {
            title: "Şarj Kablosu 7",
            image: "/assets/products/7.png",
            stats: [
                { label: faz, values: [ucFaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper20] },
                { label: kabloUzunlugu, values: [Cable8] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-seti-8m-trifaze-20a"
        },

        {
            title: "Şarj Kablosu 8",
            image: "/assets/products/8.png",
            stats: [
                { label: faz, values: [ucFaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper32] },
                { label: kabloUzunlugu, values: [Cable8] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-seti-8m-trifaze-32a"
        },

        {
            title: "Kablo Şarj seti Seti 1",
            image: "/assets/products/9.png",
            stats: [
                { label: faz, values: [tekfaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper20] },
                { label: kabloUzunlugu, values: [Cable5] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-prizi-5m-monofaze-20a"
        },

        {
            title: "Kablo Şarj seti Seti 2",
            image: "/assets/products/10.png",
            stats: [
                { label: faz, values: [tekfaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper32] },
                { label: kabloUzunlugu, values: [Cable5] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-prizi-5m-monofaze-32a"
        },

        {
            title: "Kablo Şarj seti Seti 3",
            image: "/assets/products/11.png",
            stats: [
                { label: faz, values: [tekfaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper20] },
                { label: kabloUzunlugu, values: [Cable8] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-prizi-8m-monofaze-20a"
        },

        {
            title: "Kablo Şarj seti Seti 4",
            image: "/assets/products/12.png",
            stats: [
                { label: faz, values: [tekfaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper32] },
                { label: kabloUzunlugu, values: [Cable8] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-prizi-8m-monofaze-32a"
        },

        {
            title: "Kablo Şarj seti Seti 5",
            image: "/assets/products/13.png",
            stats: [
                { label: faz, values: [ucFaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper20] },
                { label: kabloUzunlugu, values: [Cable5] },
            ],  
            link: "https://www.datechmarket.com/kablolu-sarj-prizi-5m-trifaze-20a"
        },

        {
            title: "Kablo Şarj seti Seti 6",
            image: "/assets/products/14.png",
            stats: [
                { label: faz, values: [ucFaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper32] },
                { label: kabloUzunlugu, values: [Cable5] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-prizi-5m-trifaze-32a"
        },

        {
            title: "Kablo Şarj seti Seti 7",
            image: "/assets/products/15.png",
            stats: [
                { label: faz, values: [ucFaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper20] },
                { label: kabloUzunlugu, values: [Cable8] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-prizi-8m-trifaze-20a"
        },

        {
            title: "Kablo Şarj seti Seti 8",
            image: "/assets/products/16.png",
            stats: [
                { label: faz, values: [ucFaz] },
                { label: ipClass, values: [ipClass54] },
                { label: amper, values: [Amper32] },
                { label: kabloUzunlugu, values: [Cable8] },
            ],
            link: "https://www.datechmarket.com/kablolu-sarj-prizi-8m-trifaze-32a"
        },

        {
            title: "Cee Norm Adaptörü",
            image: "/assets/products/BKT-0111-2211 copy.png",
            stats: [
                { label: prizSecenekleri, values: ["5x16A. 380V"] },
                { label: fisSecenekleri, values: ["1x16A. 220V"] },
                { label: kabloSecenekleri, values: ["30cm"] },
                { label: kabloTipi, values: ["3x2,5mm"] },
            ],
            link: "https://www.datechmarket.com/cee-norm-adaptor-3x25-ttr-116a-fis-516a-priz-30cm-kablolu",
        },
        {
            title: "Cee Norm Adaptörü",
            image: "/assets/products/BKT-0111-2211 copy.png",
            stats: [
                { label: prizSecenekleri, values: ["5x32A. 380V"] },
                { label: fisSecenekleri, values: ["1x16A. 220V"] },
                { label: kabloSecenekleri, values: ["30cm"] },
                { label: kabloTipi, values: ["3x2,5mm"] },
            ],
            link: "https://www.datechmarket.com/cee-norm-adaptor-3x25-ttr-116a-fis-532a-priz-30cm-kablolu"
        },
        {
            title: "Cee Norm Adaptörü",
            image: "/assets/products/BKT-0511-2211 copy.png",
            stats: [
                { label: prizSecenekleri, values: ["5x16A. 380V"] },
                { label: fisSecenekleri, values: ["3x16A. 220V"] },
                { label: kabloSecenekleri, values: ["30cm"] },
                { label: kabloTipi, values: ["3x2,5mm"] },
            ],
            link: "https://www.datechmarket.com/cee-norm-adaptor-3x25-ttr-316a-fis-516a-priz-30cm-kablolu"
        },
        {
            title: "Cee Norm Adaptörü",
            image: "/assets/products/BKT-0511-2211 copy.png",
            stats: [
                { label: prizSecenekleri, values: ["5x32A. 380V"] },
                { label: fisSecenekleri, values: ["3x16A. 220V"] },
                { label: kabloSecenekleri, values: ["30cm"] },
                { label: kabloTipi, values: ["3x2,5mm"] },
            ],
            link: "https://www.datechmarket.com/cee-norm-adaptor-3x25-ttr-316a-fis-532a-priz-30cm-kablolu"
        },
        {
            title: "Cee Norm Adaptörü",
            image: "/assets/products/kk.png",
            stats: [
                { label: prizSecenekleri, values: ["5x16A. 380V"] },
                { label: fisSecenekleri, values: ["5x32A. 220V"] },
                { label: kabloSecenekleri, values: ["30cm"] },
                { label: kabloTipi, values: ["3x2,5mm"] },
            ],
            link: "https://www.datechmarket.com/cee-norm-adaptor-5x25-ttr-516a-fis-532a-priz-30cm-kablolu"
        },

        {
            title: "Cee Norm Adaptörü",
            image: "/assets/products/kk.png",
            stats: [
                { label: prizSecenekleri, values: ["5x32A. 380V"] },
                { label: fisSecenekleri, values: ["5x16A. 220V"] },
                { label: kabloSecenekleri, values: ["30cm"] },
                { label: kabloTipi, values: ["3x2,5mm"] },
            ],
            link: "https://www.datechmarket.com/cee-norm-adaptor-5x25-ttr-532a-fis-516a-priz-30cm-kablolu"
        },
    ];
    // MonocardData

    // AdaptersData
    const AdaptersData = [
        {
            title: "V2L Adaptör tek soketli",
            image: "/assets/products/adapters/C2L1.jpg",
            stats: [
                { label: "V2L (Vehicle-to-Load) adaptör", values: ["elektrikli aracınızın güçlü bataryasını taşınabilir bir elektrik kaynağına dönüştüren cihazdır - evinizdeki elektronik aletleri, kamp ekipmanlarını veya acil durum cihazlarını aracınızın bataryasından besleyebilirsiniz"] },
            ],
            link: "https://www.datechmarket.com/v2l-tek-cikisli-adaptor"
        },
        {
            title: "V2L Adaptör tek uzun soketli",
            image: "/assets/products/adapters/C2L1L.jpg",
            stats: [
                { label: "V2L (Vehicle-to-Load) adaptör", values: ["elektrikli aracınızın güçlü bataryasını taşınabilir bir elektrik kaynağına dönüştüren cihazdır - evinizdeki elektronik aletleri, kamp ekipmanlarını veya acil durum cihazlarını aracınızın bataryasından besleyebilirsiniz"] },
            ],
            link: "https://www.datechmarket.com/v2l-tekli-uzatma-priz-adaptor-3m-kablolu"
        }, {
            title: "V2L Adaptör çift uzun soketli",
            image: "/assets/products/adapters/C2L2.jpg",
            stats: [
                { label: "V2L (Vehicle-to-Load) adaptör", values: ["elektrikli aracınızın güçlü bataryasını taşınabilir bir elektrik kaynağına dönüştüren cihazdır - evinizdeki elektronik aletleri, kamp ekipmanlarını veya acil durum cihazlarını aracınızın bataryasından besleyebilirsiniz"] },
            ],
            link: "https://www.datechmarket.com/v2l-2li-uzatma-priz-adaptor-3m-kablolu"
        },

        {
            title: "V2L Adaptör üçlü uzun soketli",
            image: "/assets/products/adapters/C2L3.jpg",
            stats: [
                { label: "V2L (Vehicle-to-Load) adaptör", values: ["elektrikli aracınızın güçlü bataryasını taşınabilir bir elektrik kaynağına dönüştüren cihazdır - evinizdeki elektronik aletleri, kamp ekipmanlarını veya acil durum cihazlarını aracınızın bataryasından besleyebilirsiniz"] },
            ],
            link: "https://www.datechmarket.com/v2l-3lu-uzatma-priz-adaptor-3m-kablolu"
        }, {

            title: "C2L Adaptör tek uzun soketli 32A",
            image: "/assets/products/adapters/V2L132.jpg",
            stats: [
                { label: "C2L (Charger-to-Load) adaptör", values: [" şarj istasyonlarındaki DC gücü doğrudan kullanmanızı sağlayan cihazdır - şarj istasyonuna bağlandığında ev tipi prizlere dönüştürerek elektronik cihazlarınızı şarj edebilir ya da çalıştırabilirsiniz."] },
            ],
            link: "https://www.datechmarket.com/c2l-532a-prizli-uzatma-fisli-adaptor-3m-kablolu"
        },

        {
            title: "C2L Adaptör tek uzun soketli",
            image: "/assets/products/adapters/V2L116.jpg",
            stats: [
                { label: "C2L (Charger-to-Load) adaptör", values: [" şarj istasyonlarındaki DC gücü doğrudan kullanmanızı sağlayan cihazdır - şarj istasyonuna bağlandığında ev tipi prizlere dönüştürerek elektronik cihazlarınızı şarj edebilir ya da çalıştırabilirsiniz."] },
            ],
            link: "https://www.datechmarket.com/c2l-tekli-uzatma-fisli-adaptor-3m-kablolu"
        }, {

            title: "C2L Adaptör çift uzun soketli",
            image: "/assets/products/adapters/V2L216.jpg",
            stats: [
                { label: "C2L (Charger-to-Load) adaptör", values: [" şarj istasyonlarındaki DC gücü doğrudan kullanmanızı sağlayan cihazdır - şarj istasyonuna bağlandığında ev tipi prizlere dönüştürerek elektronik cihazlarınızı şarj edebilir ya da çalıştırabilirsiniz."] },
            ],
            link: "https://www.datechmarket.com/c2l-2li-uzatma-fisli-adaptor-3m-kablolu"
        },

        {
            title: "C2L Adaptör üçlü uzun soketli",
            image: "/assets/products/adapters/V2L316.jpg",
            stats: [
                { label: "C2L (Charger-to-Load) adaptör", values: [" şarj istasyonlarındaki DC gücü doğrudan kullanmanızı sağlayan cihazdır - şarj istasyonuna bağlandığında ev tipi prizlere dönüştürerek elektronik cihazlarınızı şarj edebilir ya da çalıştırabilirsiniz."] },
            ],
            link: "https://www.datechmarket.com/c2l-3lu-uzatma-fisli-adaptor-3m-kablolu"
        },
    ];

    // RFIDData
    const RFIDData = [
        {
            title: "RFID Kontrol Kartı",
            image: "/assets/products/cCard.png",
            stats: [
                { label: kullanimi, values: ["Cihazınızı kontrol etmek için RFID kartınız"] },
            ],
        },
        {
            title: "RFID Master Kartı",
            image: "/assets/products/mCard.png",
            stats: [
                { label: kullanimi, values: ["Cihazınızı yönetmek için RFID kartınız"] },
            ],
        },
    ];
    // PCBData
    const PCBData = [
        {
            title: "Kontrol PCB Kart",
            image: "/assets/products/pcb.png",
            stats: [
                { label: ozellik, values: ["Kontrol Kartı PCB"] },
            ],
        },
        {
            title: "Yüksek Voltaj Kartı",
            image: "/assets/products/pcb.png",
            stats: [
                { label: ozellik, values: ["Yüksek Voltaj Cihazı PCB"] },
            ],
        },
        {
            title: "Akıllı Kontrol Kartı",
            image: "/assets/products/pcb.png",
            stats: [
                { label: ozellik, values: ["Akıllı Kontrol Cihazı PCB"] },
            ],
        },
        {
            title: "GSM Kartı",
            image: "/assets/products/pcb.png",
            stats: [
                { label: ozellik, values: ["Gsm kartı PCB"] },
            ],
        },
    ];
    const StantData = [
        {
            title: "Stant Kapaklı",
            image: "/assets/products/ayak.png",
            stats: [
                { label: kullanimi, values: ["Modern görünümüyle ve kapaklı stantınız"] },
            ],
        },
        {
            title: "Stant Klasik",
            image: "/assets/products/ayak-2.png",
            stats: [
                { label: kullanimi, values: ["Modern görünümüyle klasik stantınız"] },
            ],
        },
    ];
    const [activeCategory, setActiveCategory] = useState('AC İstasyonlar');
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const categoryParam = params.get('category');
        if (categoryParam) {
            setActiveCategory(categoryParam);
        }
    }, [location.search]);
    const handleCategoryClick = (category) => {
        setActiveCategory(category);
        
        const params = new URLSearchParams();
        params.set('category', category);
        
        navigate({
            pathname: '/products',
            search: params.toString()
        }, { replace: true });
    };
    const categories = {
        'DC İstasyonlar': 'dc',
        'AC İstasyonlar': 'ac-view', // Özel bir identifier ekleyelim
        'Kablolar': DualcardData,
        'Adaptörler': AdaptersData,
        'Elektronik Devreler': PCBData,
        'RFID Kartlar': RFIDData,
        'Stantlar': StantData,
        // 'Dağıtım Panoları': DistributionBoardsData
    };


    // URL'den index parametresini alıyoruz
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const categoryParam = params.get('category');
        const modelType = params.get('model');

        if (categoryParam) {
            setActiveCategory(categoryParam);
            // Sayfa yüklendiğinde en üste scroll et
            window.scrollTo(0, 0);
        }

        if (modelType && categoryParam === 'AC İstasyonlar') {
            setTimeout(() => {
                const element = document.getElementById(modelType);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);
        }
    }, [activeCategory, location.search]);



    return (
        <div>
            <div className="category-menu">
                {Object.keys(categories).map((category) => (
                    <button
                        key={category}
                        className={`category-button ${category === activeCategory ? "active" : ""}`}
                        onClick={() => handleCategoryClick(category)}
                    >
                        {category}
                    </button>
                ))}
            </div>

            <div className="Page">
                {activeCategory === 'AC İstasyonlar' ? (
                    <div>
                        <Promotion
                            Header="AC İstasyonlar"
                            Footer="AC şarj istasyonlarımız, ticari ve konut alanlarındaki elektrikli araç şarj ihtiyaçlarınızı, ekonomik ve verimli biçimde karşılamak üzere tasarlanmıştır."
                            Footer2="4 farklı model AC şarj istasyonumuz ile her türlü ihtiyacınıza uygun çözümler sunuyoruz."
                        />
                        <HomePageProductLists />
                        <WaveAnimation />
                        <MobileAppinstruction />
                    </div>
                ) : activeCategory === 'DC İstasyonlar' ? (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '400px',
                        fontSize: '24px',
                        fontWeight: 'bold'
                    }}>
                        <h2>Yakında</h2>
                    </div>
                ) : (
                    categories[activeCategory]?.map((card, index) => (
                        <div className="Card" key={index} id={`card-${index}`}>
                            <div className="CardImageContainer">
                                <img
                                    className="CardImage"
                                    src={card.image}
                                    alt={card.title}
                                />
                            </div>
                            <h4 className="CardTitle">{card.title}</h4>
                            {card.stats && (
                                <div className="CardMargin" >
                                    <ul className="CardStats">
                                        {card.stats.map((stat, statIndex) => (
                                            <li key={statIndex}>
                                                <strong>{stat.label}:</strong>{" "}
                                                {stat.values.join(" / ")}
                                            </li>
                                        ))}
                                    </ul>
                                    <a href={card.link} className="CardButtonBlue">Satın Al</a>
                                    
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default ProductList;
